import React from "react";
import AppBar from "@mui/material/AppBar";
import Avatar from '@mui/material/Avatar';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AccountMenu from "../Components/AccountMenu";
import { useAuth } from "../Contexts/useAuth";
import { NavLink } from 'react-router-dom';

const Header = () => {
  const { currentUser } = useAuth();
  //console.log(currentUser)
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <AccountMenu />
            <Avatar alt="Brand Logo" src="./logo.jpg" sx={{mr: 2}} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {currentUser}
            </Typography>
            <NavLink to="/dashboard"><Button variant="contained" color="secondary">Dashboard</Button></NavLink>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default Header;
